module.exports = __webpack_public_path__ + "img/MOCAM-1080p-Pairing-Mode_Light_poster.d01f2d18.png";